import * as environment from '../../../config/environment';
 
import { BaseAPI } from "../../BaseAPI";
 
class EBordroAPI extends BaseAPI {
 
 
    constructor() {
        const baseUrl = environment.API_URL + "BordroListe";
        super(baseUrl);
    }
 
 
    getEBordroListe(tcKimlikNo?:number, yili?: number, bordroAyi?: number) {
 
        var request = new EBordroListeRequest(tcKimlikNo, yili, bordroAyi);
        return this.post("", request, false);
 
    }
 
}
export default new EBordroAPI();
class EBordroListeRequest {
    public TcKimlikNo?: number;
    public Yili?: number;
    public BordroAyi?: number;
    constructor(tcKimlikNo?:number, yili?: number, bordroAyi?: number) {
        this.TcKimlikNo = tcKimlikNo;
        this.Yili = yili;
        this.BordroAyi = bordroAyi;
 
    }
}
export { EBordroListeRequest };